import React, { useRef } from 'react';
import { DocTabs } from './DocTabs';
import { DocSidebar } from './DocSidebar';
import { DocTableOfContents } from './DocTableOfContents';
import styles from './DocLayout.module.css';

interface DocLayoutProps {
  children: React.ReactNode;
}

export const DocLayout: React.FC<DocLayoutProps> = ({ children }) => {
  const mainRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.docLayout}>
      <DocTabs />
      <div className={styles.columns}>
        <div className={styles.sidebar}>
          <DocSidebar />
        </div>
        <div className={styles.main} ref={mainRef}>
          <div className={styles.mainInner}>
            {children}
          </div>
        </div>
        <div className={styles.toc}>
          <DocTableOfContents scrollContainerRef={mainRef} />
        </div>
      </div>
    </div>
  );
};
